import ErrorPage from "./views/ErrorPage"
import LoginPage from "./views/LoginPage"
import OrderListPage from "./views/OrderListPage"
import PurchaseAttachDetail from "./views/PurchaseAttachDetail"
import PurchaseAttachList from "./views/PurchaseAttachList"
import TransferAttachDetail from "./views/TransferAttachDetail"
import TransferAttachList from "./views/TransferAttachList"

const routesConfig = [
  { path: "/", Component: OrderListPage, protected: true },
  { path: "/purchase/:orderNo", Component: PurchaseAttachList, protected: true },
  { path: "/transfer/:transferId", Component: TransferAttachList, protected: true },
  { path: "/purchase/:orderNo/attachment", Component: PurchaseAttachDetail, protected: true },
  { path: "/transfer/:transferId/attachment", Component: TransferAttachDetail, protected: true },
  { path: "/error", Component: ErrorPage, protected: true },
  { path: "/login", Component: LoginPage, protected: false },
]

export default routesConfig
